import { render, staticRenderFns } from "./MessengerDetail.vue?vue&type=template&id=384fcfc3&scoped=true&"
import script from "./MessengerDetail.vue?vue&type=script&lang=js&"
export * from "./MessengerDetail.vue?vue&type=script&lang=js&"
import style0 from "./MessengerDetail.vue?vue&type=style&index=0&id=384fcfc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384fcfc3",
  null
  
)

export default component.exports